// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__19WaN","Small":"Logo__Small__VJEDX","ExtraSmall":"Logo__ExtraSmall__1vl4Q","Medium":"Logo__Medium__3d3rP","Large":"Logo__Large__3tRZF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 364
// module chunks = 0